import { Message } from "semantic-ui-react";

function MessagePadrao({ content }) {
  return (
    <Message
      negative
      header="Não foi possível prosseguir"
      content={content}
      style={{
        width: "90%",
        margin: "1em auto 2em",
        textAlign: "center",
      }}
    />
  );
}

export default MessagePadrao;
